import React from 'react';
import qs from 'qs';
import './FeaturedSection.css';

// utils
import callApi from '../../utils/callApi';

// constants
import {
  FEATURED_LIST_ALL,
  FEATURED_LIST_SEGMENTS,
  FEATURED_LIST_AUDITIONS,
  FEATURED_LIST_BLOGPOSTS,
} from '../../constants/apiUrls/apiUrls';
import { LIVE_CAMS_URL } from '../../constants/liveCams';

// components
import NewsHomeComponent from '../generalComponents/NewsHomeComponent/NewsHomeComponent';

// images
import vaultImg1 from '../../assets/vault/naked-news-premium-snapchat-f726a45f.png';
// import vaultImg2 from '../../assets/vault/the-naked-news-online-store-is-now-open-08d09a0a_thumbnail.jpg';
import vaultImg3 from '../../assets/vault/alaskan-cruise-giveaway-enter-here-f4b1b857_thumbnail.jpg';
import vaultImg4 from '../../assets/vault/haylie-brae-on-naked-news-sep-13-15-f1b7d15a_thumbnail.png';
import vaultImg5 from '../../assets/vault/vote-for-marina-valmont-in-maximsfinest-94bcaa84_thumbnail.png';
import Adds from '../Adds/Adds';
import LiveEvents from '../LiveEvents/LiveEvents';

import FeaturedItems from './FeaturedItems';

/* const PageSubnavLinks = [
    'All',
    'Segments',
    'Auditions',
    'Blog Posts',
    'From the vault'
]; */

class FeaturedSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      typeOfListing: 'all',
      featuredItems: [],
      cams: [],
      size: this.props.size || 15,
      isLoading: false,
      showLoadMoreButton: true,
    };
  }

  getUrlByTypeOfListing = () => {
    const { typeOfListing } = this.state;

    switch (typeOfListing) {
      case 'segments':
        return FEATURED_LIST_SEGMENTS;
      case 'auditions':
        return FEATURED_LIST_AUDITIONS;
      case 'blogposts':
        return FEATURED_LIST_BLOGPOSTS;
      default:
        return FEATURED_LIST_ALL;
    }
  };

  loadMore = () => {
    const { size } = this.state;
    this.setState({ isLoading: true, size: size + 15 }, () =>
      this.fetchFeaturedItemsList()
    );
  };

  fetchFeaturedItemsList = () => {
    const { size } = this.state;
    const urlByTypeOfListing = this.getUrlByTypeOfListing();
    const url = urlByTypeOfListing.
      replace('{page}', 0).
      replace('{size}', size);
    callApi(url, 'get', {}).then((res) => {
      this.setState({
        featuredItems: res.data,
        isLoading: false,
        showLoadMoreButton: !(size > res.data.length),
      });
    });
  };

  componentDidMount = () => {
    const { location } = this.props;

    callApi(LIVE_CAMS_URL, 'get', {}, {}, {}, false, false).
      then((res) => this.setState({ cams: res.data }));

    if (location && location.search && !location.search.includes('showSignupPopup')) {
      const parsedSearch = qs.parse(location.search, { ignoreQueryPrefix: true });

      switch (parsedSearch.filter) {
        case 'segments':
          this.setState({ typeOfListing: parsedSearch.filter }, () =>
            this.fetchFeaturedItemsList());
          break;

        case 'auditions':
          this.setState({ typeOfListing: parsedSearch.filter }, () =>
            this.fetchFeaturedItemsList());
          break;

        case 'vault':
          this.setState({ typeOfListing: 'fromthevault' });
          break;

        case 'posts':
          this.setState({ typeOfListing: 'blogposts' }, () =>
            this.fetchFeaturedItemsList());
          break;
        default:
          break;
      }
    } else {
      this.fetchFeaturedItemsList();
    }
  };

  getVaultContent = () => (
    <div className="content">
      <div className="container">
        <div className="content-grid-container">
          <div className="content-grid">
            <div className="content-item-container">
              <a
                className="content-item "
                href="https://www.facebook.com/events/168474070335421/"
                title="Cruise To Alaska With Naked News & LLV - Details Here"
              >
                <div className="content-item-thumbnail">
                  <img
                    alt="Xlthumb placeholder"
                    src={vaultImg3}
                    style={{ opacity: 1 }}
                  />
                </div>
                <div className="content-item-caption">
                  <div className="content-item-category">
                    Naked Notes
                  </div>
                  <div className="content-item-title">
                    Cruise To Alaska With Naked News
                    &amp; LLV - Details Here
                  </div>
                </div>
              </a>
            </div>
            <div className="content-item-container">
              <a
                className="content-item "
                href="/home"
                title="Hayley Bray on Naked News Sep 13 - 15"
              >
                <div className="content-item-thumbnail">
                  <img
                    alt="Xlthumb placeholder"
                    src={vaultImg4}
                    style={{ opacity: 1 }}
                  />
                </div>
                <div className="content-item-caption">
                  <div className="content-item-category">
                    Naked Notes
                  </div>
                  <div className="content-item-title">
                    Hayley Bray on Naked News Sep 13 -
                    15
                  </div>
                </div>
              </a>
            </div>
            <div className="content-item-container">
              <a
                className="content-item "
                href="https://maximsfinest.com/2017/marina-valmont"
                title="Vote for Marina Valmont in #MaximsFinest"
              >
                <div className="content-item-thumbnail">
                  <img
                    alt="Xlthumb placeholder"
                    src={vaultImg5}
                    style={{ opacity: 1 }}
                  />
                </div>
                <div className="content-item-caption">
                  <div className="content-item-category">
                    Naked Notes
                  </div>
                  <div className="content-item-title">
                    Vote for Marina Valmont in
                    #MaximsFinest
                  </div>
                </div>
              </a>
            </div>
            <div className="content-item-container">
              <a
                className="content-item "
                href="https://fancentro.com/thenakednews"
                rel="noopener noreferrer"
                target="_blank"
                title="Naked News Premium Snapchat"
              >
                <div className="content-item-thumbnail">
                  <img
                    alt="Xlthumb placeholder"
                    src={vaultImg1}
                    style={{ opacity: 1 }}
                  />
                </div>
                <div className="content-item-caption">
                  <div className="content-item-category">
                    Naked Notes
                  </div>
                  <div className="content-item-title">
                    Naked News Premium Snapchat
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  historyPush = (filter) => {
    this.props.history.push({ search: `filter=${filter}` });
  };

  handleClick = (e) => {
    const preparedTargetValue = e.currentTarget.text.
      toLowerCase().
      replace(/\s/g, '');

    e.preventDefault();

    switch (preparedTargetValue) {
      case 'all':
        this.props.history.push({ search: '' });
        break;

      case 'segments':
        this.historyPush(preparedTargetValue);
        break;

      case 'auditions':
        this.historyPush(preparedTargetValue);
        break;

      case 'blogposts':
        this.historyPush('posts');
        break;

      case 'fromthevault':
        this.historyPush('vault');
        break;
      default:
        break;
    }

    if (preparedTargetValue === 'fromthevault') {
      this.setState({ typeOfListing: preparedTargetValue });
    } else {
      this.setState({ typeOfListing: preparedTargetValue }, () =>
        this.fetchFeaturedItemsList()
      );
    }
  };

  render() {
    const { typeOfListing, featuredItems, isLoading, showLoadMoreButton, cams } = this.state;
    const { history } = this.props;
    const renderItems = typeOfListing !== 'fromthevault';

    return (
      <React.Fragment>
        <div className="content">
          <div className="container sections-arranged space-evenly">
            <NewsHomeComponent />
            <LiveEvents history={history} />
          </div>
        </div>
        <div className="content">
          <div className="container">
            <Adds />
          </div>
        </div>
        {renderItems ? (
          <FeaturedItems
            cams={cams}
            featuredItems={featuredItems}
            isLoading={isLoading}
            loadMore={this.loadMore}
            showLoadMoreButton={showLoadMoreButton}
            typeOfListing={typeOfListing}
          />
        ) : (
          this.getVaultContent()
        )}
      </React.Fragment>
    );
  }
}

export default FeaturedSection;
